import { useMemo } from 'react';

import { mobileBreakpoint, useIsMobile, useL10n } from '@uplift/hooks';
import { Alert } from '@uplift/ui-v2';

import { useBillingContext } from '../billing.context';
import { useCurrentuser } from '@uplift/contexts';


export const CardStatusBanner: React.VFC = () => {
  const { cardStatus, outstandingPaymentsCount } = useBillingContext();
  const l10n = useL10n();
  const me = useCurrentuser();
  const isMobile = useIsMobile(mobileBreakpoint);

  const alert = useMemo(() => {
    if (me?.rules.nonpayment) {
      return (
        <Alert flat={isMobile} severity="warning" showIcon={false} title={l10n.accountSettings.billing.limitedAccount}>
          {l10n.accountSettings.billing.deactivatedAccount}
        </Alert>
      );
    }

    switch (cardStatus) {
      case 'declined':
        if (!outstandingPaymentsCount || outstandingPaymentsCount <= 1) {
          return <Alert flat={isMobile} severity="error">{l10n.accountSettings.billing.cardWasDeclined}</Alert>;
        }
        if (outstandingPaymentsCount === 2) {
          return (
            <Alert flat={isMobile} severity="error" title={l10n.accountSettings.billing.cardIsDeclined}>
              {l10n.accountSettings.billing.twoUnpaidServices} {l10n.accountSettings.billing.updateYourPaymentMethod2}
            </Alert>
          );
        }
        if (outstandingPaymentsCount >= 3) {
          return (
            <Alert flat={isMobile} severity="error" title={l10n.accountSettings.billing.cardIsDeclined}>
              {l10n.accountSettings.billing.threeUnpaidServices} {l10n.accountSettings.billing.updateYourPaymentMethod3}
            </Alert>
          );
        }
        break;

      case 'expired':
        if (!outstandingPaymentsCount || outstandingPaymentsCount <= 1) {
          return <Alert flat={isMobile} severity="error">{l10n.accountSettings.billing.cardIsExpired}</Alert>;
        }
        if (outstandingPaymentsCount === 2) {
          return (
            <Alert flat={isMobile} severity="error" title={l10n.accountSettings.billing.cardIsExpiredTitle}>
              {l10n.accountSettings.billing.twoUnpaidServices} {l10n.accountSettings.billing.updateYourPaymentMethod2}
            </Alert>
          );
        }
        if (outstandingPaymentsCount >= 3) {
          return (
            <Alert flat={isMobile} severity="error" title={l10n.accountSettings.billing.cardIsExpiredTitle}>
              {l10n.accountSettings.billing.threeUnpaidServices} {l10n.accountSettings.billing.updateYourPaymentMethod3}
            </Alert>
          );
        }
        break;
    }
  }, [ cardStatus, outstandingPaymentsCount, l10n, me, isMobile ]);

  if (!cardStatus || !alert) {
    return null;
  }

  return alert;
};
